// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Pixel";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
*,
*::before,
*::after {
  box-sizing: border-box;
  font-family: "Pixel", monospace;
  /* user-select: none; */
}

body {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  text-shadow: 2px 2px 1px white;
  image-rendering: pixelated;
  overflow: hidden;
  background-color: transparent;
}

.world {
  overflow: hidden;
  /* overflow-x: hidden;
  overflow-y: hidden; */
  position: relative;
}

.score {
  position: absolute;
  font-size: 7vmin;
  right: 1vmin;
  top: 1vmin;
}

.start-screen {
  position: absolute;
  width: 33%;
  max-width: 750px;
  height: auto;
  font-size: 5vmin;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.hide {
  display: none !important;
}

.sky {
  z-index: -1;
  position: absolute;
  width: 100%;

  bottom: -100px;
}

.sea {
  z-index: 0;
  position: absolute;
  width: 300%;
  bottom: 0px;
  left: calc(var(--left) * 1%);
}

.ship {
  --bottom: 0;
  z-index: 2;
  position: absolute;
  left: 15%;
  height: 25%;
  bottom: calc(var(--bottom) * 1%);
  filter: drop-shadow(1px 1px 0px white) drop-shadow(-1px -1px 0px white)
    drop-shadow(-1px 1px 0px white) drop-shadow(1px -1px 0px white)
    brightness(1.2);
}

.rock {
  z-index: 1;
  --bottom: 0;
  position: absolute;
  left: calc(var(--left) * 1%);
  height: 30%;
  bottom: 0;
}
.show {
  display: block;
}
.end-screen {
  z-index: 999;
  position: absolute;
  width: 100%;
  max-width: 500px;
  height: auto;
  /* max-height: 50%; */

  overflow: scroll;
  font-size: 4vmin;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* background-color: darkgray;
  padding: 2rem;
  border: 2px solid; */
}

.end-screen h2 {
  font-size: 3.5vmin;
  margin: 1rem 0 2rem 0;
}

.end-form {
  font-size: 3vmin;
  background-color: darkgray;
  padding: 10%;
  border: 2px solid;
}

.final-score {
  display: flex;
  margin: 0.5rem 0;
  padding: 5px;

  background-color: #ffdb2c;
}

.submit-button {
  display: flex;
  margin: 0.1rem 0;
  padding: 2% 5%;
  font-size: 3vmin;
  border: 1px solid;
  background-color: #d4d4d4;
  -webkit-box-shadow: inset -1px -1px 0px 0px rgba(0, 0, 0, 1);
  -moz-box-shadow: inset -1px -1px 0px 0px rgba(0, 0, 0, 1);
  box-shadow: inset -1px -1px 0px 0px rgba(0, 0, 0, 1);
  cursor: pointer;
}

.submit-button:hover {
  color: white;
  background-color: #a6a6a6;
}

.restart-button {
  display: flex;
  margin: 1rem auto;
}

#playerName {
  font-size: 3vmin;
  color: #505050;
  margin: 0.5rem 0;
  width: 100%;
}
.player-address {
  margin: 0.5rem 0 1rem 0;
  /* color: #505050; */
  font-size: 2vmin;
}

.top-players {
  background-color: darkgray;
  padding: 2rem;
  border: 2px solid;
  max-height: 70vh;
  overflow: scroll;
}

.top-players-table {
  font-size: 1rem;
  width: 100%;
}

/* Navbar */
#logo-image {
  height: 100%;
}
/* ~~ Top Navigation Bar ~~ */

#navigation-container {
  width: 100%;
  margin: 0 auto;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem;
}

.navigation-bar {
  color: #fff;
  position: absolute;
  top: 0;
  background-color: #071428;
  height: 70px;
  width: 100%;
  text-align: center;
  text-shadow: none;
}
.navigation-bar img {
  float: left;
}
.navigation-bar ul {
  padding: 0.5rem;
  margin: 0px;
  text-align: center;
  display: inline-block;
  vertical-align: top;
}

.navigation-bar li {
  list-style-type: none;
  padding: 0px;
  height: 24px;
  margin-top: 4px;
  margin-bottom: 4px;
  display: inline;
}

.navigation-bar li a {
  color: white;
  font-size: 16px;
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  text-decoration: none;
  line-height: 70px;
  padding: 5px 15px;
  opacity: 0.7;
}

#menu {
  float: right;
}

.welcome {
  font-size: 2vmin;
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.welcome span {
  line-height: 2;
  color: #00000060;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,4CAAsB;AACxB;AACA;;;EAGE,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;;EAEjB,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB;uBACqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;;EAEX,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC;;mBAEiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;;EAErB,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC;;sBAEoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,4DAA4D;EAC5D,yDAAyD;EACzD,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,WAAW;AACX;EACE,YAAY;AACd;AACA,6BAA6B;;AAE7B;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yDAAyD;EACzD,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: \"Pixel\";\n  src: url(\"./font.ttf\");\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  font-family: \"Pixel\", monospace;\n  /* user-select: none; */\n}\n\nbody {\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n\n  text-shadow: 2px 2px 1px white;\n  image-rendering: pixelated;\n  overflow: hidden;\n  background-color: transparent;\n}\n\n.world {\n  overflow: hidden;\n  /* overflow-x: hidden;\n  overflow-y: hidden; */\n  position: relative;\n}\n\n.score {\n  position: absolute;\n  font-size: 7vmin;\n  right: 1vmin;\n  top: 1vmin;\n}\n\n.start-screen {\n  position: absolute;\n  width: 33%;\n  max-width: 750px;\n  height: auto;\n  font-size: 5vmin;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.hide {\n  display: none !important;\n}\n\n.sky {\n  z-index: -1;\n  position: absolute;\n  width: 100%;\n\n  bottom: -100px;\n}\n\n.sea {\n  z-index: 0;\n  position: absolute;\n  width: 300%;\n  bottom: 0px;\n  left: calc(var(--left) * 1%);\n}\n\n.ship {\n  --bottom: 0;\n  z-index: 2;\n  position: absolute;\n  left: 15%;\n  height: 25%;\n  bottom: calc(var(--bottom) * 1%);\n  filter: drop-shadow(1px 1px 0px white) drop-shadow(-1px -1px 0px white)\n    drop-shadow(-1px 1px 0px white) drop-shadow(1px -1px 0px white)\n    brightness(1.2);\n}\n\n.rock {\n  z-index: 1;\n  --bottom: 0;\n  position: absolute;\n  left: calc(var(--left) * 1%);\n  height: 30%;\n  bottom: 0;\n}\n.show {\n  display: block;\n}\n.end-screen {\n  z-index: 999;\n  position: absolute;\n  width: 100%;\n  max-width: 500px;\n  height: auto;\n  /* max-height: 50%; */\n\n  overflow: scroll;\n  font-size: 4vmin;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  /* background-color: darkgray;\n  padding: 2rem;\n  border: 2px solid; */\n}\n\n.end-screen h2 {\n  font-size: 3.5vmin;\n  margin: 1rem 0 2rem 0;\n}\n\n.end-form {\n  font-size: 3vmin;\n  background-color: darkgray;\n  padding: 10%;\n  border: 2px solid;\n}\n\n.final-score {\n  display: flex;\n  margin: 0.5rem 0;\n  padding: 5px;\n\n  background-color: #ffdb2c;\n}\n\n.submit-button {\n  display: flex;\n  margin: 0.1rem 0;\n  padding: 2% 5%;\n  font-size: 3vmin;\n  border: 1px solid;\n  background-color: #d4d4d4;\n  -webkit-box-shadow: inset -1px -1px 0px 0px rgba(0, 0, 0, 1);\n  -moz-box-shadow: inset -1px -1px 0px 0px rgba(0, 0, 0, 1);\n  box-shadow: inset -1px -1px 0px 0px rgba(0, 0, 0, 1);\n  cursor: pointer;\n}\n\n.submit-button:hover {\n  color: white;\n  background-color: #a6a6a6;\n}\n\n.restart-button {\n  display: flex;\n  margin: 1rem auto;\n}\n\n#playerName {\n  font-size: 3vmin;\n  color: #505050;\n  margin: 0.5rem 0;\n  width: 100%;\n}\n.player-address {\n  margin: 0.5rem 0 1rem 0;\n  /* color: #505050; */\n  font-size: 2vmin;\n}\n\n.top-players {\n  background-color: darkgray;\n  padding: 2rem;\n  border: 2px solid;\n  max-height: 70vh;\n  overflow: scroll;\n}\n\n.top-players-table {\n  font-size: 1rem;\n  width: 100%;\n}\n\n/* Navbar */\n#logo-image {\n  height: 100%;\n}\n/* ~~ Top Navigation Bar ~~ */\n\n#navigation-container {\n  width: 100%;\n  margin: 0 auto;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0.5rem;\n}\n\n.navigation-bar {\n  color: #fff;\n  position: absolute;\n  top: 0;\n  background-color: #071428;\n  height: 70px;\n  width: 100%;\n  text-align: center;\n  text-shadow: none;\n}\n.navigation-bar img {\n  float: left;\n}\n.navigation-bar ul {\n  padding: 0.5rem;\n  margin: 0px;\n  text-align: center;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.navigation-bar li {\n  list-style-type: none;\n  padding: 0px;\n  height: 24px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  display: inline;\n}\n\n.navigation-bar li a {\n  color: white;\n  font-size: 16px;\n  font-family: \"Trebuchet MS\", Arial, Helvetica, sans-serif;\n  text-decoration: none;\n  line-height: 70px;\n  padding: 5px 15px;\n  opacity: 0.7;\n}\n\n#menu {\n  float: right;\n}\n\n.welcome {\n  font-size: 2vmin;\n  position: absolute;\n  top: 70%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n.welcome span {\n  line-height: 2;\n  color: #00000060;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
